<template>
  <MenuLink v-if="menuItem.href" :item="menuItem"/>

  <v-list-group
      v-else
      :prepend-icon="menuItem.icon"
      no-action
  >
    <template v-slot:activator>
      <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
    </template>
    <template v-for="item in menuItem.items">
      <template v-if="!item.caslAction || $can(item.caslAction, item.caslSubject)">
        <v-list-group
            v-if="item.items && item.items.length"
            :key="item.title"
            :value="true"
            no-action
            sub-group
        >
          <template #activator>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
              v-for="subItem in item.items"
              :key="subItem.title"
              link
              :to="subItem.url"
          >
            <v-list-item-title v-text="subItem.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <MenuLink :item="item" :key="item.title" />
      </template>
    </template>
  </v-list-group>
</template>

<script>
import {accountCan} from "@/utils/account.utils";
import {mapGetters} from "vuex";
import MenuLink from "@components/mainNav/MenuLink.vue";

export default {
  name: 'MenuItem',
  components: {MenuLink},
  props: {
    menuItem: {
      type: Object,
      required:true
    }
  },
  computed:{
    ...mapGetters('account', ['account']),
  },
  methods: {
    accountCan,
  }
}
</script>